import React from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { withRouter } from "react-router-dom";

import * as setupReducer from "containers/Setup/reducer";
import * as oldProjectReducer from "containers/OldProject/reducer";
import * as homeReducer from "containers/Home/reducer";

import Models from "components/CurrentState/Models";

class ModelsContainer extends React.PureComponent {
  render() {
    const { id } = this.props;

    return <Models {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const id = ownProps.id ? ownProps.id : "new";

  return {
    initRun: () => dispatch(oldProjectReducer.updateStep("run")),
    updateModelOptions: (modelId, isIncluded) => dispatch(setupReducer.updateModelOptions(id, modelId, isIncluded))
  };
};

const mapStateToProps = (state, ownProps) => {
  const id = ownProps.id ? ownProps.id : "new";

  return {
    id: id,
    modelOptions: setupReducer.getModelOptionsArr(state, id),
    customModelURL: homeReducer.getCustomModelURL(state),
    outcomeType: setupReducer.getOutcomeType(state, id)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(ModelsContainer);
